import { useFormContext } from 'react-hook-form';

import { useCart } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/hooks/useCart';
import { StoredCart } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/types/StoredCart';

export const useLastCartsSelector = () => {
  const { setValue } = useFormContext();
  const { createNewCartFromStoredCart } = useCart();

  const setSelectedValue = (option: StoredCart) => {
    const newCart = createNewCartFromStoredCart(option);
    if (newCart) {
      setValue(
        'items',
        newCart.items.map((item) => ({
          ...item.data,
        })),
      );
    }
  };

  return { setSelectedValue };
};
